import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericCrudService } from './generic-crud.service';
const API_URL = environment.prismaApiUrl +'/api/dispo/mails';

@Injectable({
    providedIn: 'root'
})
export class MailService extends GenericCrudService<Product>{

    attachments: any = [];
    
    constructor(http: HttpClient) {
        super(http, 'api/dispo/mails');
    }

    setAttachments(attachments) {
        this.attachments = attachments;
    }

    getAttachments() {
        return this.attachments;
    }

    killlAttachments() {
        this.attachments = null;
    }

    /** E-Mail-Typen (z. B. Terminanfrage, Auftrag/Dokumente) für Dropdown / Versandort. */
    getMailTypes(): Observable<any[]> {
        return this.http.get<any[]>(environment.prismaApiUrl + '/api/dispo/mail-types');
    }

}

export interface Product {
    id: number;
    name: string;
    price: number;
    // Weitere Eigenschaften deines Produkts
}

